import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';
import { Exploitation } from 'src/app/bo/hiboo/exploitation';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Equipment } from 'src/app/bo/equipment';
import { Observable } from 'rxjs';
import { Shift } from 'src/app/bo/shifts/shift';
import { BlastEquipmentsData } from 'src/app/bo/hiboo/getDataByBlastEquipmentsAndShift';

@Injectable({
  providedIn: 'root'
})
export class HibooService {

  private readonly cacheExploitationByTirId = new Map<number, Exploitation>();
  private readonly cacheShiftsByTirId = new Map<number, Shift[]>();
  private cacheEquipments: Equipment[] = [];

  constructor(
    private readonly http: HttpService,
  ) { }


  getExploitationDataByTirId(siteId: number, tirId: number, startDate: Date, endDate: Date): Observable<Exploitation> {
    const exploitation = this.cacheExploitationByTirId.get(tirId);

    if (exploitation != null) return of(exploitation);

    return this.http.get<Exploitation>(`Hiboo/${siteId}/GetExploitationByBlast/${tirId}?startDate=${startDate}&endDate=${endDate}`).pipe(
      map(response => {
        this.cacheExploitationByTirId.set(tirId, response);
        return response;
      })
    )
  }

  getExploitationDataByTirEquipmentsAndTime(siteId: number, obj: BlastEquipmentsData): Observable<Exploitation> {
    return this.http.post<BlastEquipmentsData, Exploitation>('Hiboo/' + siteId + '/RetrieveExploitationDataByBlastEquipments/', obj).pipe(
      map(response => {
        return response;
      })
    )
  }

  getEquipmentsBySiteId(siteId: number): Observable<Equipment[]> {
    if (this.cacheEquipments.length > 0) return of(this.cacheEquipments);

    return this.http.get<Equipment[]>('Hiboo/' + siteId + '/GetMobileEquipments/').pipe(
      map(response => {
        this.cacheEquipments = response;
        console.log(response);
        return response;
      })
    )
  }

  getShiftsByTirId(siteId: number, tirId: number): Observable<Shift[]> {
    console.log(siteId);
    const shifts = this.cacheShiftsByTirId.get(tirId);

    if (shifts != null && shifts.length > 0) return of(shifts);

    return this.http.get<Shift[]>('Blasts/' + siteId + '/shiftsByTirId/' + tirId).pipe(
      map(response => {
        console.log(response);
        this.cacheShiftsByTirId.set(tirId, response);
        return response;
      })
    )
  }

  updateCacheShifts(tirId: number, shifts: Shift[]) {
    this.cacheShiftsByTirId.set(tirId, shifts);
  }
}
